import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { useContentHeaderLayout } from '@/contexts/BreadcrumbContext';

interface ProjectsSearchToolbarProps {
  placeholder: string;
  compactPlaceholder?: string;
  ariaLabel: string;
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export function ProjectsSearchToolbar({
  placeholder,
  compactPlaceholder = 'Search…',
  ariaLabel,
  searchQuery,
  onSearchChange,
}: ProjectsSearchToolbarProps) {
  const compact = useContentHeaderLayout().compact;
  const [focused, setFocused] = useState(false);
  const showCompactPlaceholder = compact && !focused && !searchQuery;

  return (
    <div className="relative w-full min-w-0">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="search"
        placeholder={showCompactPlaceholder ? compactPlaceholder : placeholder}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        className="h-9 rounded-full border-border bg-background pl-10 text-sm shadow-none focus-visible:ring-1"
        aria-label={ariaLabel}
      />
    </div>
  );
}
